import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import isEmpty from 'lodash/isEmpty';

import createReducer from './reducers';

const storeState = localStorage.getItem('store');
let initialState = {};
if (!isEmpty(storeState)) {
  initialState = { ...JSON.parse(storeState) };
  localStorage.removeItem('store');
}

function configureStore(_initialState = {}) {
  const middlewares = [thunk];
  const enhancers = [applyMiddleware(...middlewares)];
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          shouldHotReload: false,
          trace: true,
          traceLimit: 25,
        })
      : compose;
  const store = createStore(createReducer(), _initialState, composeEnhancers(...enhancers));

  return store;
}

const store = configureStore(initialState);

export default store;
